import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const FlipCardSlider = ({ data, title }) => {
  const { height, width } = useWindowDimensions();
  const [slidesPerView, setSlidesPerView] = useState(1);

  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.swiper.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.swiper.slideNext();
  };

  useEffect(() => {
    if (width >= 320 && width < 480) {
      setSlidesPerView(1);
    } else if (width >= 480 && width < 600) {
      setSlidesPerView(2);
    } else if (width >= 600 && width < 1080) {
      setSlidesPerView(3);
    } else if (width >= 1080) {
      setSlidesPerView(4);
    } else {
      setSlidesPerView("auto");
    }
  }, [width]);
  return (
    <>
      <div className="stories-header mb-3">
        <h2>{title || "Discover Our Journeys & Insights"}</h2>
        <div className="section-nav">
          <div className="left-btn">
            <button className="nav-btn" onClick={handlePrev}>
              <i class="fa-solid fa-arrow-left"></i>
            </button>
          </div>
          <div className="right-btn">
            <button className="nav-btn" onClick={handleNext}>
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <Swiper
        spaceBetween={30}
        slidesPerView={slidesPerView}
        ref={swiperRef}
        modules={[Navigation]}
        className="swiper-container"
      >
        {data?.map((item, index) => (
          <SwiperSlide className="story-card">
            <div className="card-inner">
              <div className="card-front">
                <img
                  src={
                    item?.thumbnail || item.imgsrc ||
                    "https://cdn.pixabay.com/photo/2016/08/15/22/20/fuel-1596622_640.jpg"
                  }
                  alt={`${item?.title || item?.short} main image`}
                />
                <div className="card-content">
                  <div className="story-caption">
                    {item?.contentType || "Article"}
                  </div>
                  <div className="story-title">
                    {item?.title || item?.short ||
                      "We saved up to 20 per cent on vehicle maintenance with Shoora"}
                  </div>
                </div>
              </div>
              <div className="card-back">
                <div className="card-content">
                  <div className="story-caption text-uppercase">
                    {item?.contentType || "Article"}
                  </div>
                  <div className="story-title">
                    {item?.description ||
                      "How Shoora’s technology helped KDG Logistics save a big         chunk on vehicle maintenance and allowed them to gain momentum and expand their profit pool."}
                  </div>
                </div>
                <div className="card-actions">
                  <div className="card-link">
                    <Link to={item?.link ? item?.link : item?.slug ? `/insights/${item?.slug}` : "#"} className="text-capitalize">
                      Read <br /> {item?.contentType || "article"}
                    </Link>
                  </div>
                  <div className="card-action-info">
                    <p>
                      {item?.readTime || 0} minute <br /> read
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default FlipCardSlider;
